import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Marketplace feed on mobile ("Novosti za Marketplace na mobilnim uređajima"): a listing card with the page on top. */
@Component({
  selector: 'app-meta-marketplace-feed-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './marketplace-feed-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/marketplace-styles.scss',
    './marketplace-feed-mobile.component.scss',
  ]
})
export class MetaMarketplaceFeedMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }
}